const docControl = {
  overview: "Обзор",
  viewHistory: "История просмотров",
  fieldLocks: "Заблокированные поля",
  messages: "Сообщения",
  auditLog: "Журнал действий",
  notFound: "Документ не найден",
  backToList: "Назад к списку",
  liveViewing: "Сейчас просматривают",
  submitters: "Подписанты",
  totalViews: "Просмотры",
  lockedFields: "Заблокированные поля",
  unreadMessages: "Непрочитанные",
  documentInfo: "Информация о документе",
  created: "Создан",
  sentAt: "Отправлен",
  signedAt: "Подписан",
  expiresAt: "Истекает",
  cancelledAt: "Отменён",
  pdfHash: "Хеш PDF",
  unnamed: "Без имени",
  role_signer: "Подписант",
  role_witness: "Свидетель",
  role_approver: "Утверждающий",
  actions: "Действия",
  markSent: "Отметить отправленным",
  cancel: "Отменить документ",
  archive: "В архив",
  statusDraft: "Черновик",
  statusSent: "Отправлено",
  statusViewed: "Просмотрено",
  statusPartial: "Частично",
  statusSigned: "Подписано",
  statusExpired: "Истёк",
  statusCancelled: "Отменён",
  statusArchived: "Архив",
  noViews: "Просмотров пока нет",
  duration: "Длительность",
  noLocks: "Нет заблокированных полей",
  lockedBy: "Заблокировано",
  unlock: "Разблокировать",
  noMessages: "Нет сообщений",
  internal: "Внутреннее",
  submitterMsg: "Подписант",
  typeMessage: "Введите сообщение...",
  noAudit: "Нет записей",
  checklist: "Чек-лист",
  noChecklist: "Нет пунктов чек-листа",
  required: "Обязательно",
  acceptedTypes: "Допустимые типы",
  maxSize: "Макс. размер",
  uploadFile: "Загрузить файл",
  uploadAnother: "Загрузить ещё",
  approve: "Одобрить",
  reject: "Отклонить",
  rejectReason: "Причина отклонения...",
  cancelAction: "Отмена",
  review_pending: "Ожидание",
  review_approved: "Одобрено",
  review_rejected: "Отклонено",
  downloadPdf: "Скачать PDF",
  generateAndStore: "Создать и сохранить PDF",
  signers: "Подписанты",
  addSigner: "Добавить подписанта",
  noSigners: "Подписанты пока не добавлены",
  sendForSigning: "Отправить на подпись",
  sendForSigningDesc: "Создать ссылку для подписи и отправить документ",
  sendNow: "Отправить",
  signingLink: "Ссылка для подписи",
  copyLink: "Копировать",
  copied: "Скопировано!",
  documentSentInfo: "Документ отправлен на подпись",
  fullName: "Полное имя",
  emailAddress: "Эл. почта",
  phoneNumber: "Телефон",
  edit: "Редактировать",
  delete: "Удалить",
  save: "Сохранить",
  declined: "Отклонён",
  fieldValues: "Значения полей",
  contentPreview: "Предпросмотр содержимого",
  showLess: "Показать меньше",
  showMore: "Показать больше",
  moreLines: "строк ещё",
  resendLink: "Отправить снова",
  sendReminder: "Напоминание",
  revokeDocument: "Отозвать",
  editContent: "Редактирование",
  editWarning: "Документ уже отправлен — редактирование доступно только для черновиков",
  noFieldValues: "Нет значений полей",
  fieldsReadOnly: "Поля только для чтения — редактирование доступно только для черновиков",
} as const;
export default docControl;
